import { render, staticRenderFns } from "./ChipMenu.vue?vue&type=template&id=310ba1be&"
import script from "./ChipMenu.vue?vue&type=script&lang=js&"
export * from "./ChipMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChipMenu.vue?vue&type=style&index=0&id=310ba1be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports